import Vue from "vue";
import Vuetify from "vuetify/lib";
import uk from "vuetify/lib/locale/uk";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  lang: {
    current: "uk",
    locales: { uk },
  },
  //https://materialdesignicons.com/
  //https://vuetifyjs.com/en/features/icon-fonts/#reusable-custom-icons
  //https://icon-sets.iconify.design/mdi/logout-variant/
  icons: {
    iconfont: "mdi", // default
    values: {
      logout: "mdi-logout-variant",
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#117973",
        primary2: "#083C39",
        teacherPrimary: "#228E6E",
        teacherSecondary: "#F1FFFB",
        white: "#FFFFFF",
        secondary: "#E9FFFE",
        orange: "#F15A22",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
});

export default vuetify;
